var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"modal",attrs:{"type":"standard"}},[_c('div',{staticClass:"announcement-modal"},[_c('wysiwyg',{attrs:{"html":_vm.body}}),_c('btn-list',{attrs:{"buttons":_vm.buttons}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }